import * as React from "react";
import { ReactNode } from "react";
import { EasingFunctions, ElementStyleAnimation, HTMLElementProperty, HTMLElementPropertyUnit } from "ts-common-utils";

interface IItemStripProps {

}

interface IItemStripState {
    overflowLeft: boolean;
    overflowRight: boolean;
}

export default class ItemStrip extends React.PureComponent<IItemStripProps, IItemStripState> {
    private _content?: HTMLDivElement ;

    constructor(props: IItemStripProps) {
        super(props);

        this.state = {
            overflowLeft: true,
            overflowRight: true
        }
        this.handleLeftArrowClick = this.handleLeftArrowClick.bind(this);
        this.handleRightArrowClick = this.handleRightArrowClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.updateOverflow = this.updateOverflow.bind(this);
    }

    public componentDidMount() {
        window.setTimeout(this.updateOverflow, 500);
    }

    private handleLeftArrowClick() {
        var positionX = this._content!.scrollLeft - this._content!.clientWidth * 0.8;
        if (positionX < 0) {
            positionX = 0;
        }
        new ElementStyleAnimation(this._content!, {
            targetPropertyValues: {[HTMLElementProperty.ScrollLeft]: {value: positionX, unit: HTMLElementPropertyUnit.Pixel}},
            easingFunction: EasingFunctions.easeOutExp
        }).animate();
    }

    private handleRightArrowClick() {
        var positionX = this._content!.scrollLeft + this._content!.clientWidth * 0.8;
        if (positionX > this._content!.scrollWidth - this._content!.clientWidth) {
            positionX = this._content!.scrollWidth - this._content!.clientWidth;
        }
        new ElementStyleAnimation(this._content!, {
            targetPropertyValues: {[HTMLElementProperty.ScrollLeft]: {value: positionX, unit: HTMLElementPropertyUnit.Pixel}},
            easingFunction: EasingFunctions.easeOutExp
        }).animate();
    }

    private handleScroll() {
        this.updateOverflow();
    }

    private updateOverflow() {
        this.setState({
            overflowLeft: this._content!.scrollLeft > 0,
            overflowRight: this._content!.scrollLeft + this._content!.clientWidth < this._content!.scrollWidth
        }); 
    }

    public render(): ReactNode {
        return (
            <div className="item-strip">
                <div className="content-container">
                    <div className="content" ref={c => this._content = c!} onScroll={this.handleScroll}>
                        {this.props.children}
                    </div>
                </div>
                <div className="arrows">
                    {this.state.overflowLeft &&
                        <div className="arrow left" onClick={this.handleLeftArrowClick}>
                            <img src="img/icons/arrow-left.svg" />
                        </div>
                    }
                    {this.state.overflowRight &&
                        <div className="arrow right" onClick={this.handleRightArrowClick}>
                            <img src="img/icons/arrow-right.svg" />
                        </div>
                    }
                </div>
            </div>
        );
    }
}